export default __webpack_public_path__ + "static/media/SWT0650.34I-36803_-21668_0.40f0b1e5.jpg";